// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__2xber","rotateSpinner":"styles_rotateSpinner__IRt9+"};